module.exports = __webpack_public_path__ + "static/media/logo-peya.faf85e1d.svg";